import * as React from 'react';
import { useState } from 'react';
import {
    BodyMediumRegular,
    DEFAULT_COLOR,
    DEFAULT_ICON,
    FruitfulCustomIcon,
    H5Emphasized,
    View,
    YStack,
} from 'smoothie';

import type { UpdateBankAccountInfo } from '../../../../types/BankAccount';
import ColorSelection from './ColorSelection';
import CreateEditButton from './CreateEditButton';

interface IconProps {
    onPressNext: (updates?: Partial<UpdateBankAccountInfo>) => void;
    accountInfo: UpdateBankAccountInfo;
}

const Color = ({ onPressNext, accountInfo }: IconProps) => {
    const [color, setColor] = useState(accountInfo.color);

    return (
        <YStack flex={1} justifyContent="space-between">
            <View>
                <H5Emphasized textAlign="center" marginVertical={12}>
                    Customize your space
                </H5Emphasized>
                <BodyMediumRegular
                    textAlign="center"
                    color="$gray1100"
                    marginBottom={36}
                >
                    Personalize your savings space based on its purpose
                </BodyMediumRegular>
                <View alignSelf="center">
                    <FruitfulCustomIcon
                        icon={accountInfo.icon}
                        color={color}
                        size="xl"
                        showShadow
                    />
                </View>
                <H5Emphasized
                    textAlign="center"
                    marginTop={24}
                    marginBottom={36}
                >
                    {accountInfo.nickname}
                </H5Emphasized>
            </View>
            <YStack gap={12}>
                <ColorSelection
                    icon={accountInfo.icon ?? DEFAULT_ICON}
                    selectedColor={color ?? DEFAULT_COLOR}
                    onSelect={(color) => {
                        setColor(color);
                    }}
                />
                <CreateEditButton
                    disabled={color == null}
                    onPress={() => {
                        onPressNext({ color });
                    }}
                />
            </YStack>
        </YStack>
    );
};

export default Color;
